/** A vertical Flexbox, filling all the space (flex === 1), and providing flex to children */

import classNames from 'classnames'
import type { HTMLAttributes, Ref } from 'react'
import styles from './vertical-box.module.css'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const VBox = ({ className, ref, ...props }: HTMLAttributes<HTMLDivElement> & { ref?: Ref<any> }) => (
  <div ref={ref} className={classNames(styles.root, className)} {...props} />
)
